import { render, staticRenderFns } from "./questionChange.vue?vue&type=template&id=e147d548&"
import script from "./questionChange.vue?vue&type=script&lang=js&"
export * from "./questionChange.vue?vue&type=script&lang=js&"
import style0 from "./questionChange.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./questionChange.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports